import React, { useState  , useEffect} from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import MongoJsonViewer from '../../../pages/Mongo_Db/MongoJsonViewer';
import Loader from '../Loader';
import { mongo_executor } from '../../../helpers/fakebackend_helper';

const Mongo_JsonViewer_Modal = ({mongo_query , database_id}) => {
const [loader, setloader] = useState(false)
const [modal_standard, setmodal_standard] = useState(false);
const [result_mongo, setresult_mongo] = useState(null)
        function tog_standard() {
            setmodal_standard(!modal_standard);
        }

const get_mongo_query_result =async ()=>{
    setloader(true)
    try {
       const result = await mongo_executor({ mongo_query , database_id })
       setresult_mongo(result)
    //    console.log("Result---->", result)

    } catch (error) {
        console.log(error)
    }
    finally{
        setloader(false)
    }
}


useEffect(() => {
if(modal_standard){
     get_mongo_query_result()
}
}, [mongo_query , modal_standard])


  return (
    <div>
        <Button color="primary" onClick={() => tog_standard()}>Run</Button>
        {/* Default Modal */}
            <Modal id="myModal"
            size="lg"
                isOpen={modal_standard}
                toggle={() => {
                    tog_standard();
                }}
            >
                <ModalHeader className="modal-title"
                    id="myModalLabel" toggle={() => {
                        tog_standard();
                    }}>

                    MongoDB JSON Viewer
                </ModalHeader>
                {loader?<Loader/>:<ModalBody>
                    <MongoJsonViewer result_mongo={result_mongo} />
                </ModalBody>}
                <div className="modal-footer">
                    <Button
                        color="light"
                        onClick={() => {
                            tog_standard();
                        }}
                    >
                        Close
                    </Button>
                    <Button
                        color="primary"
                    >
                        Export
                    </Button>
                </div>
            </Modal>
    </div>
  )
}

export default Mongo_JsonViewer_Modal